import { Text, View } from 'react-native'
import { styled } from '~/core/styled'
import { convertLineHeight } from '~/utils'

export const ProductInfo = styled(View, theme => {
  return {
    base: {
      height: 20,
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1,
      width: theme.sizingHuge + theme.sizingMicro,
    },
    variants: {
      hasIcon: {
        true: { gap: theme.spacingInlineNone, width: theme.sizingLarge },
        false: {
          gap: theme.spacingInlineOnepulse,
        },
      },
    },
  }
})

export const ProductInfoContainer = styled(Text, theme => {
  return {
    base: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      color: theme.colorTextNeutralAlternative,
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreeandhalfpulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
    },
  }
})

export const ProductInfoMark = styled(Text, theme => {
  return {
    base: {
      height: 20,
      width: 20,
      textAlign: 'center',
      color: theme.colorTextNeutralAlternative,
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreeandhalfpulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
    },
  }
})

export const ProductInfoText = styled(Text, theme => {
  return {
    base: {
      maxWidth: '80%',
      color: theme.colorTextNeutralAlternative,
      gap: theme.spacingInlineOnepulse,
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreeandhalfpulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
    },
    variants: {
      hasIcon: {
        true: {
          marginRight: theme.spacingInlineOnepulse,
          marginLeft: theme.spacingInlineOnepulse,
        },
        false: { marginRight: theme.spacingInlineOnepulse },
      },
    },
  }
})
